import { Auditable } from "../shared/auditable.model";

export class IncidentNoteModel extends Auditable {
  id: number;
  value: string;
}
